import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import mixin from './mixin';
import i18n from './i18n'

Vue.config.productionTip = false

new Vue({
	vuetify,
	router,
	store,
	i18n,
	mixin,
	render: h => h(App)
}).$mount('#app')
